export default "__VITE_ASSET__Ca6L$5yT__"